// Import centralized media config
import { mediaConfig, getFileType, formatFileSize } from '@/config/media'

// Re-export from centralized config for backward compatibility
export const FILE_CONFIGS = mediaConfig.formats


// Keep only the functions that are unique to this file
export function getSupportedFormats(type = null) {
  if (type && mediaConfig.formats[type]) {
    return mediaConfig.formats[type].extensions.join(', ')
  }
  
  const formats = {
    images: mediaConfig.formats.image.extensions.join(', '),
    videos: mediaConfig.formats.video.extensions.join(', '),
    audio: mediaConfig.formats.audio.extensions.join(', ')
  }
  
  return formats
}

export function getAcceptString(types = ['image', 'video', 'audio']) {
  const accepts = []
  
  types.forEach(type => {
    if (mediaConfig.formats[type]) {
      mediaConfig.formats[type].extensions.forEach(ext => {
        accepts.push('.' + ext)
      })
      // Also add generic mime types
      if (type === 'image') accepts.push('image/*')
      if (type === 'video') accepts.push('video/*')
      if (type === 'audio') accepts.push('audio/*')
    }
  })
  
  return accepts.join(',')
}

export function generateThumbnail(file) {
  return new Promise((resolve, reject) => {
    const fileType = getFileType(file)

    if (fileType === 'image') {
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          
          // Calculate thumbnail dimensions using config
          const maxSize = Math.max(mediaConfig.display.thumbnailSize.width, mediaConfig.display.thumbnailSize.height)
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > maxSize) {
              height = (height * maxSize) / width
              width = maxSize
            }
          } else {
            if (height > maxSize) {
              width = (width * maxSize) / height
              height = maxSize
            }
          }

          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)

          canvas.toBlob((blob) => {
            resolve(URL.createObjectURL(blob))
          }, 'image/jpeg', 0.8)
        }
        img.onerror = reject
        img.src = e.target.result
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    } else if (fileType === 'video') {
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.onloadedmetadata = () => {
        video.currentTime = 0
      }
      video.onseeked = () => {
        const canvas = document.createElement('canvas')
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(video, 0, 0)
        
        canvas.toBlob((blob) => {
          URL.revokeObjectURL(video.src)
          resolve(URL.createObjectURL(blob))
        }, 'image/jpeg', 0.8)
      }
      video.onerror = () => {
        URL.revokeObjectURL(video.src)
        resolve(null) // Return null for video thumbnails that fail
      }
      video.src = URL.createObjectURL(file)
    } else {
      resolve(null) // No thumbnail for audio files
    }
  })
}